import React, { lazy } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
// Minimal coordinate presence
const CoordinateGrid = () => <div className="absolute inset-0 w-full h-full opacity-[0.015] pointer-events-none" style={{
  backgroundImage: 'linear-gradient(#F5F5F5 0.5px, transparent 0.5px), linear-gradient(90deg, #F5F5F5 0.5px, transparent 0.5px)',
  backgroundSize: '80px 80px'
}} aria-hidden="true" data-id="element-613" />;
export function Careers() {
  return <>
      <Helmet data-id="element-614">
        <title data-id="element-615">Careers — Lazy Monk Labs</title>
        <meta name="description" content="We work with people who can lose everything without losing themselves. Building diagnostic systems for human patterns." data-id="element-616" />
        <meta name="robots" content="index, follow" data-id="element-617" />
      </Helmet>

      <div className="min-h-screen bg-[#0A0A0A] text-[#F5F5F5]" data-id="element-618">
        {/* Navigation */}
        <header data-id="element-619">
          <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-620">
            <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-621">
              <Link to="/" className="flex items-center gap-3 hover:opacity-80 transition-opacity" data-id="element-622">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-8 w-auto" width="32" height="32" data-id="element-623" />
                <span className="text-base font-mono tracking-tight text-gray-400" data-id="element-624">
                  Lazy Monk Labs
                </span>
              </Link>
              <div className="flex items-center gap-8" data-id="element-625">
                <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-626">
                  Decoder
                </Link>
                <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-627">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" data-id="element-628">
                  Contact
                </a>
              </div>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-629">
          {/* 1. OPENING STATEMENT */}
          <section className="relative py-32 md:py-40 px-6 overflow-hidden" data-id="element-630">
            <CoordinateGrid data-id="element-631" />
            <div className="relative z-10 max-w-4xl mx-auto space-y-16" data-id="element-632">
              <h1 className="text-4xl md:text-6xl lg:text-7xl font-serif leading-[1.1] text-[#F5F5F5]" style={{
              fontFamily: 'Georgia, serif'
            }} data-id="element-633">
                We work with people who can lose everything without losing
                themselves.
              </h1>
            </div>
          </section>

          {/* 2. WHAT WE ARE BUILDING */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-634">
            <div className="max-w-4xl mx-auto space-y-12" data-id="element-635">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-636">
                What we are building
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-637">
                <p data-id="element-638">
                  Lazy Monk Labs is building diagnostic systems for human
                  patterns.
                </p>
                <p data-id="element-639">
                  Products like Decoder and Conscious OS treat the human mind
                  like an operating system — something that can be diagnosed,
                  understood, and re-architected.
                </p>
                <p className="text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-640">
                  We are not building a company. We are building a
                  civilization-grade system for how humans understand themselves
                  and their patterns.
                </p>
              </div>
            </div>
          </section>

          {/* 3. THE MISSION */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-641">
            <div className="max-w-4xl mx-auto space-y-12" data-id="element-642">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-643">
                The mission
              </h2>

              <div className="space-y-8 text-lg text-gray-400 leading-relaxed" data-id="element-644">
                <p data-id="element-645">The world runs on broken mental operating systems.</p>
                <p data-id="element-646">
                  Most suffering, bad decisions, bad leadership, and bad
                  organizations come from undiagnosed inner systems.
                </p>
                <p className="text-[#F5F5F5]" data-id="element-647">
                  Lazy Monk Labs is building the diagnostic and engineering
                  layer for human consciousness.
                </p>
              </div>
            </div>
          </section>

          {/* 4. THE BUILDER'S RESILIENCE FILTER */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-648">
            <div className="max-w-4xl mx-auto space-y-16" data-id="element-649">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-650">
                What we look for
              </h2>

              <div className="space-y-12" data-id="element-651">
                <div className="space-y-4" data-id="element-652">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-653">
                    Capacity to Bet
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-654">
                    You've chosen uncertainty over comfort at least once in your
                    life.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-655">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-656">
                    Ego Containment
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-657">
                    You can admit when you're wrong without protecting your
                    identity.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-658">
                  <h3 className="text-xl font-medium text-[#F5F5F5]" data-id="element-659">
                    Regenerative Confidence
                  </h3>
                  <p className="text-lg text-gray-400 leading-relaxed" data-id="element-660">
                    You trust your ability to rebuild more than any single
                    outcome.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* 5. WHO SHOULD APPLY (AND WHO SHOULDN'T) */}
          <section className="py-24 px-6 bg-[#111214] border-t border-[#2B2B2B]" data-id="element-661">
            <div className="max-w-4xl mx-auto" data-id="element-662">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-16" data-id="element-663">
                <div className="space-y-8" data-id="element-664">
                  <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-665">
                    This is not for people who
                  </h2>
                  <div className="space-y-4 text-gray-500" data-id="element-666">
                    <p data-id="element-667">• Want safety-first careers</p>
                    <p data-id="element-668">• Need structure before responsibility</p>
                    <p data-id="element-669">• Want a brand name more than a mission</p>
                    <p data-id="element-670">• Want to be told what to do</p>
                  </div>
                </div>

                <div className="space-y-8" data-id="element-671">
                  <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-672">
                    This is for people who
                  </h2>
                  <div className="space-y-4 text-gray-400" data-id="element-673">
                    <p data-id="element-674">• Want to build something that didn't exist before</p>
                    <p data-id="element-675">• Are comfortable with ambiguity and first principles</p>
                    <p data-id="element-676">
                      • Want their work to matter at a civilizational, not
                      cosmetic, level
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* 6. WHAT WE ARE NOT */}
          <section className="py-24 px-6 border-t border-[#2B2B2B]" data-id="element-677">
            <div className="max-w-4xl mx-auto space-y-8" data-id="element-678">
              <h2 className="text-2xl font-medium text-[#F5F5F5]" data-id="element-679">
                What we are not
              </h2>

              <div className="space-y-4 text-lg text-gray-500" data-id="element-680">
                <p data-id="element-681">• Not a self-help company</p>
                <p data-id="element-682">• Not a coaching business</p>
                <p data-id="element-683">• Not an astrology or spirituality brand</p>
                <p data-id="element-684">• Not a motivational content company</p>
              </div>

              <p className="text-lg text-[#F5F5F5] pt-6 border-t border-[#2B2B2B]" data-id="element-685">
                We are building diagnostic systems. Calm. Precise. Serious.
              </p>
            </div>
          </section>

          {/* 7. CALL TO ACTION */}
          <section className="py-32 px-6 relative overflow-hidden border-t border-[#2B2B2B]" data-id="element-686">
            <CoordinateGrid data-id="element-687" />
            <div className="relative z-10 max-w-4xl mx-auto space-y-12" data-id="element-688">
              <div className="space-y-8" data-id="element-689">
                <p className="text-xl md:text-2xl text-gray-400 leading-relaxed" data-id="element-690">
                  We are not running a hiring process.
                  <br data-id="element-691" />
                  We are assembling a very small group of builders.
                </p>

                <p className="text-lg text-[#F5F5F5] leading-relaxed pt-6 border-t border-[#2B2B2B]" data-id="element-692">
                  If you read this and felt a quiet "yes" — write to:{' '}
                  <a href="mailto:anish@lazymonklabs.com" className="underline hover:text-gray-400 transition-colors" data-id="element-693">
                    anish@lazymonklabs.com
                  </a>
                </p>
              </div>

              <div className="pt-8 space-y-6 text-base text-gray-500 leading-relaxed border-t border-[#2B2B2B]" data-id="element-694">
                <p className="text-[#F5F5F5]" data-id="element-695">Don't send a resume.</p>
                <p data-id="element-696">Send a note about:</p>
                <div className="space-y-3 pl-6" data-id="element-697">
                  <p data-id="element-698">• What you've built</p>
                  <p data-id="element-699">• What you've broken</p>
                  <p data-id="element-700">• What you've rebuilt</p>
                </div>
              </div>
            </div>
          </section>
        </main>

        {/* Footer */}
        <footer className="py-12 px-6 border-t border-[#2B2B2B]" data-id="element-701">
          <div className="max-w-6xl mx-auto" data-id="element-702">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-8" data-id="element-703">
              <div data-id="element-704">
                <p className="text-sm text-gray-500 font-mono" data-id="element-705">
                  Lazy Monk Labs
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-706">
                  Pattern recognition systems
                </p>
              </div>

              <div className="flex gap-8 text-sm text-gray-500" data-id="element-707">
                <Link to="/decoder" className="hover:text-[#F5F5F5] transition-colors" data-id="element-708">
                  Decoder
                </Link>
                <Link to="/careers" className="hover:text-[#F5F5F5] transition-colors" data-id="element-709">
                  Careers
                </Link>
                <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="hover:text-[#F5F5F5] transition-colors" data-id="element-710">
                  Contact
                </a>
              </div>

              <div className="text-xs text-gray-600 font-mono" data-id="element-711">
                © {new Date().getFullYear()}
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>;
}